module.exports = __webpack_public_path__ + "static/media/instagram-logo.34ada163.png";